export const itemNameWithDimension = (v) => {
  return `${v.nama_item ?? v.nama_item_aset ?? v.uraian_pekerjaan} 
    ${v.tb && v.lb && v.pj ? `(${v.tb} x ${v.lb} x ${v.pj})` : ''}
  `;
};
